import { render, staticRenderFns } from "./left_tabs.vue?vue&type=template&id=6bb42150&scoped=true"
import script from "./left_tabs.vue?vue&type=script&lang=js"
export * from "./left_tabs.vue?vue&type=script&lang=js"
import style0 from "./left_tabs.vue?vue&type=style&index=0&id=6bb42150&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb42150",
  null
  
)

export default component.exports